import { render } from "./Subnets.vue?vue&type=template&id=490b6b86&scoped=true"
import script from "./Subnets.vue?vue&type=script&lang=js"
export * from "./Subnets.vue?vue&type=script&lang=js"

import "./Subnets.vue?vue&type=style&index=0&id=490b6b86&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490b6b86"]])

export default __exports__